import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { AdminKeyUpSellProps } from '../src/AdminKeyUpSell.tsx';

export const AdminKeyUpSell: LoadableType<AdminKeyUpSellProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdminKeyUpSell" */ '../src/AdminKeyUpSell.tsx'))
			.AdminKeyUpSell,
});
